import { Train, Car, Bus, Bed, MapPin, Info } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../../components/Reveal";
import { Eyebrow, Button } from "../../components/Bits";

const travel = [
  { icon: Train, title: "By train", body: "Whitehaven station sits on the scenic Cumbrian Coast Line, with connections via Carlisle and Barrow. The harbour is a short, flat walk from the platform." },
  { icon: Car, title: "By car", body: "Whitehaven is reached via the A595. Town centre and harbourside pay-and-display car parks are a few minutes' walk from the festival site." },
  { icon: Bus, title: "By bus", body: "Regular Stagecoach services run into Whitehaven town centre from across west Cumbria, dropping you close to the harbour." },
];

const stay = [
  { title: "In Whitehaven", body: "Hotels, guesthouses and B&Bs in and around the town centre put you within walking distance of the harbour and the festival." },
  { title: "Around the coast", body: "St Bees, Egremont and the wider Copeland coast offer characterful places to stay a short drive away." },
  { title: "The Lake District", body: "The western Lakes, including Ennerdale and Wasdale, are on the doorstep if you fancy making a weekend of it." },
];

export default function PrideVisit() {
  return (
    <div>
      <section className="container-x py-16 md:py-20">
        <Reveal>
          <Eyebrow className="text-nead-pink">Visit</Eyebrow>
          <h1 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight text-nead-navy">Plan your trip to the harbourside.</h1>
          <p className="mt-5 max-w-2xl text-lg text-nead-navy/65 leading-relaxed">
            Whitehaven is an easy place to reach and a lovely place to stay. Here is how to get here and where to rest your head.
          </p>
        </Reveal>

        <div className="mt-12">
          <div className="flex items-center gap-2 text-nead-navy"><MapPin className="h-5 w-5 text-nead-pink" /><h2 className="font-display font-bold text-2xl">Getting here</h2></div>
          <Stagger className="mt-6 grid md:grid-cols-3 gap-6">
            {travel.map((t) => (
              <StaggerItem key={t.title}>
                <div className="h-full rounded-[1.5rem] border border-black/[0.07] p-8">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full grad-pink-cyan"><t.icon className="h-6 w-6 text-white" strokeWidth={1.8} /></div>
                  <h3 className="mt-6 font-display font-bold text-xl text-nead-navy">{t.title}</h3>
                  <p className="mt-3 text-nead-navy/60 leading-relaxed">{t.body}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="bg-nead-mist">
        <div className="container-x py-16 md:py-20">
          <div className="flex items-center gap-2 text-nead-navy"><Bed className="h-5 w-5 text-nead-pink" /><h2 className="font-display font-bold text-2xl">Where to stay</h2></div>
          <Stagger className="mt-6 grid md:grid-cols-3 gap-6">
            {stay.map((s) => (
              <StaggerItem key={s.title}>
                <div className="h-full rounded-[1.5rem] bg-white border border-black/[0.07] p-8">
                  <h3 className="font-display font-bold text-xl text-nead-navy">{s.title}</h3>
                  <p className="mt-3 text-nead-navy/60 leading-relaxed">{s.body}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
          <div className="mt-8 flex items-start gap-3 rounded-2xl border border-black/10 bg-white p-5 text-sm text-nead-navy/70">
            <Info className="h-5 w-5 flex-none text-nead-pink" />
            <p>Book accommodation early, the Whitehaven Weekender is our busiest weekend of the year. A short drive opens up even more options across the coast and Lakes.</p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button to="/pride/whats-on" variant="pink" testId="visit-whatson">See what's on</Button>
            <Button to="/pride/lineup" variant="outline" testId="visit-lineup">Main stage lineup</Button>
          </div>
        </div>
      </section>
    </div>
  );
}
